const MessagesError = {
  unauthenticated: 'This user is unauthorized.',
  forbidden:
    'Access Denied: You do not have permission to access this resource',
  somethingWentWrong: 'Something went wrong. Please try again later.',
  resourceNotFound: 'Resource not found!',
};

export { MessagesError };
